
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IContainerTypesModel,
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";
import { createCustomerWhole, getCustomer } from "@/api/customer";
import {
  batchDeleteShippingOrders,
  confirmPutShipping,
  createShippingOrderContainerType,
  creatShipping,
  deleteShippingOrderContainerType,
  getShippingOrderStatus,
  searchShippingOrder,
  updateShippingOrderContainerType,
} from "@/api/shipping-order";
// import { cloneDeep } from "lodash";
import { getContainerType } from "@/api/container-type";
import { getUsersByJobPosition } from "@/api/users";
import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { property } from "lodash";
// import { isShallow } from "vue";

@Component({
  name: "ShippingOrderManagement",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private isShowMore = false;
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private sellerList: IUserModel[] = [];
  private actionName = {
    create: "新增",
    createContainerType: "新增柜型",
    editContainerType: "编辑柜型",
    confirmPutShipping: "确认放舱",
  };
  public shippingOrderStatusList: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  //   vxe表格数据
  private loading = false;
  private columns2 = [];
  private tableData = [
    {
      id: 10001,
      name: "Test1",
      role: "Develop",
      sex: "Man",
      age: 28,
      address: "test abc",
    },
    {
      id: 10002,
      name: "Test2",
      role: "Test",
      sex: "Women",
      age: 22,
      address: "Guangzhou",
    },
    {
      id: 10003,
      name: "Test3",
      role: "PM",
      sex: "Man",
      age: 32,
      address: "Shanghai",
    },
    {
      id: 10004,
      name: "Test4",
      role: "Designer",
      sex: "Women",
      age: 23,
      address: "test abc",
    },
    {
      id: 10005,
      name: "Test5",
      role: "Develop",
      sex: "Women",
      age: 30,
      address: "Shanghai",
    },
    {
      id: 10006,
      name: "Test6",
      role: "Designer",
      sex: "Women",
      age: 21,
      address: "test abc",
    },
    {
      id: 10007,
      name: "Test7",
      role: "Test",
      sex: "Man",
      age: 29,
      address: "test abc",
    },
    {
      id: 10008,
      name: "Test8",
      role: "Develop",
      sex: "Man",
      age: 35,
      address: "test abc",
    },
  ];
  private rule = {
    billLadingCode: [
      { required: true, message: "海运提单号不能为空", trigger: "blur" },
    ],
    company: [{ required: true, message: "请选择公司", trigger: "blur" }],
    shippingMark: [
      { required: true, message: "请输入发货唛头", trigger: "blur" },
    ],
    code: [{ required: true, message: "请输入客户编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入客户全称", trigger: "blur" }],
    address: [{ required: true, message: "请输入客户地址", trigger: "blur" }],
    abbreviation: [
      { required: true, message: "请输入客户简称", trigger: "blur" },
    ],
    tel: [{ required: true, message: "请输入客户电话", trigger: "blur" }],
    country: [{ required: true, message: "请输入国家", trigger: "blur" }],
    departures: [{ required: true, message: "请输入出口港", trigger: "blur" }],
    tradeCountry: [
      { required: true, message: "请输入贸易国", trigger: "blur" },
    ],
    departure: [{ required: true, message: "请输入处境关别", trigger: "blur" }],
    transportation: [
      { required: true, message: "请输入运输方式", trigger: "blur" },
    ],
    destinationCountry: [
      { required: true, message: "请输入最终目的国", trigger: "blur" },
    ],
    deliveryCountry: [
      { required: true, message: "请输入运抵国", trigger: "blur" },
    ],
    internationalTradeTerms: [
      { required: true, message: "请选择国际贸易条款", trigger: "blur" },
    ],
    portDischarge: [
      { required: true, message: "请输入指运港", trigger: "blur" },
    ],
    payment: [{ required: true, message: "请选择付款方式", trigger: "blur" }],
    paymentDetails: [
      { required: true, message: "请输入付款方式详情", trigger: "blur" },
    ],
    ladingType: [
      { required: true, message: "请输入提单类型", trigger: "blur" },
    ],
    sinosure: [
      { required: true, message: "请选择是否单个保中信保", trigger: "blur" },
    ],
    notifier: [{ required: true, message: "请输入通知人", trigger: "blur" }],
    notifierAddress: [
      { required: true, message: "请输入通知人地址", trigger: "blur" },
    ],
    seller: [{ required: true, message: "请选择销售员", trigger: "blur" }],
  };

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "C&F", value: "3" },
  ];

  private paymentOptions = [
    { label: "定金", value: "1" },
    { label: "赊账付款(OA)", value: "2" },
    { label: "信用证(L/C)", value: "3" },
    { label: "付款交单(DP)", value: "4" },
    { label: "发货前付款", value: "5" },
    { label: "见提单付款", value: "6" },
    { label: "其它", value: "7" },
  ];

  private ladingTypeOptions = [
    { label: "正本", value: "1" },
    { label: "SWB", value: "2" },
    { label: "电放", value: "3" },
    { label: "异地放单", value: "4" },
    { label: "铁路运单COPY", value: "6" },
    { label: "公路运单", value: "7" },
  ];

  private selectSinosureOptions = [
    { label: "是", value: true },
    { label: "否", value: false },
  ];

  private JobPositionType = {
    seller: "seller",
    purchaser: "purchaser",
    logisticsClerk: "logistics-clerk",
  };
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;

  public payload = {} as WriteShippingOrderInput;

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  public listParam = {
    shippingCode: null,
    status: null,
    startDate: null,
    endDate: null,
    pageNumber: 1,
    pageSize: 8,
    dateRange: null,
    customerKeyword: "",
    saleName: "",
  };
  created() {
    // 获取所有列配置
    this.$nextTick(() => {
      const table = this.$refs.xTable2 as any;
      let list = table.getColumns();
      let needList = [
        "DESCRIPTION1",
        "DESCRIPTION2",
        "DESCRIPTION3",
        "DESCRIPTION4",
        "PRODUCT NAME",
        "采购折扣",
        "采购单价",
        "销售折扣",
        "销售报价",
      ];
      this.columns2 = list.filter((item) => {
        return needList.includes(item.property);
      });
    });
    this.loading = true;
    setTimeout(() => {
      // 将指定列设置为隐藏状态
      this.columns2.forEach((column) => {
        column.visible = false;
      });
      if (this.$refs.xTable2) {
        const table = this.$refs.xTable2 as any;
        table.refreshColumn();
      }
      this.loading = false;
    }, 800);
    this.initContainerTypeList();
    this.initSellerList();
    this.getList();
    this.initShippingOrderStatusList();
  }

  activated() {
    this.initContainerTypeList();
    this.initSellerList();
    this.getList();
    this.initShippingOrderStatusList();
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  private handleFilter() {
    this.listParam.pageNumber = 1;
    this.getList();
  }

  private async initShippingOrderStatusList() {
    const { status }: any = await getShippingOrderStatus();
    this.shippingOrderStatusList = status;
  }

  private async getList() {
    const params = { ...this.listParam };
    if (params.dateRange?.length > 0) {
      params.startDate = this.listParam.dateRange[0];
      params.endDate = this.listParam.dateRange[1];
      params.dateRange = null;
    }
    if (params.startDate > params.endDate) {
      Message({
        message: "结束日期必须大于起始日期",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.listLoading = false;
    const { total, content }: any = await searchShippingOrder(params);
    this.total = total;
    this.shippingOrder = content;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  //新增对话框确认回调
  private onDialogConfirmed() {
    if (this.dialogStatus === "create") {
      this.doCreateData();
    }
  }

  //新增订舱单回调
  private doCreateData() {
    //表单校验
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        //没有客户的id接下来去创建
        if (!this.payload.customerId) {
          const { id }: any = await createCustomerWhole(this.payload);
          this.payload.customerId = id;
        }
        //有客户的id去更新一下客户表    并且创建订舱单
        await creatShipping(this.payload);
        this.dialogFormVisible = false;
        this.$notify({
          title: "成功",
          message: "创建成功",
          type: "success",
          duration: 2000,
        });
        //查询列表
        await this.getList();
      }
    });
  }

  private async deleteContainerType(containerTypeId: string) {
    await deleteShippingOrderContainerType(containerTypeId);
    this.selectedRow.containerTypeList =
      this.selectedRow.containerTypeList.filter(
        (value) => value.id !== containerTypeId
      );
  }

  //新增订舱单页面
  private showCreateShippingOrderDialog(action: string) {
    //弹框的数据模型
    this.payload = new WriteShippingOrderInput();
    this.dialogStatus = action;
    //显示新增弹框
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  //新增界面检索客户信息
  private async searchCustomer() {
    const customerCode = this.payload.code;
    if (customerCode) {
      const data = (await   getCustomer(customerCode)) as WriteShippingOrderInput;
      data.company = this.payload.company;
      data.shippingMark = this.payload.shippingMark;
      this.payload = { ...data };
    }
  }

  //页面加载就加载柜型信息
  private async initContainerTypeList() {
    const data: any = await getContainerType();
    // this.containerTypeOptionsList = data;
  }

  //新增柜型编辑柜型弹框
  private showOperateDialog(action: string, data: ShippingOrderModel) {
    //回显新增柜型操作列表数据
    // this.payload = cloneDeep(data);
    this.selectedRow = data;
    if (action === "createContainerType") {
      //显示新增或编辑柜型对话框
      this.containerTypeVisible = true;
    } else if (action === "editContainerType") {
      //todo 根据订舱单id去查询该订舱单下的柜型
      // const data: any = searchContainerTypesByShippingOrder(data);
      // this.payload.containerTypes = data;
      this.containerTypeVisible = true;
      this.listLoading = false;
    } else if (action === "confirmPutShipping") {
      this.payload = new WriteShippingOrderInput();
      this.confirmPutShippingVisible = true;
    }
    //对话框的一个状态 ,新增/编辑柜型的对话框
    this.dialogStatus = action;
  }

  //页面加载就加载全部用户
  private async initSellerList() {
    const data: any = await getUsersByJobPosition(this.JobPositionType.seller);
    this.sellerList = data;
  }

  private totalContainerQuantity = 0;

  @Watch("configuredContainerTypes", { deep: true, immediate: true })
  private selectedRows: IDefaultShippingOrderModel[] = [];
}

class WriteShippingOrderInput {
  id: string;
  code: string; //客户编号
  name = ""; //客户全称
  abbreviation = ""; //客户简称
  address = ""; //客户地址
  tel = ""; //客户电话
  country = ""; //国家
  departures = ""; //出口港
  tradeCountry = ""; //贸易国
  departure = ""; //出境关别
  transportation = ""; //运输方式
  destinationCountry = ""; //最终目的国
  deliveryCountry = ""; //运抵国
  portDischarge = ""; //指运港
  internationalTradeTerms = ""; //国际贸易条款
  payment = ""; //付款方式
  paymentDetails = ""; //付款方式详情
  ladingType = ""; //提单类型
  sinosure = null; //是否是单个保中信保
  notifier = ""; //通知人
  notifierAddress = ""; //通知人地址
  seller: string; //销售员
  customerId: string; //客户
  startDate: Moment; //开始时间
  billLadingCode = ""; //海运提单号
  typeCount: number; // 共计提柜数量
  combinedContainer: boolean; // 是否拼柜
  containerTypes: IContainerTypesModel[] = [];
  shippingMark = "";
  company: string;
}
